import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { AboutSection } from './components/about-section'
import { ContactSection } from './components/contact-section'
import { HeroCarousel } from './components/hero-carousel'
import { SectorsSection } from './components/sectors-section'
import { SiteFooter } from './components/site-footer'
import { SiteHeader } from './components/site-header'

/**
 * Keeps the document title and meta description in step with the active
 * language. With no router and no SSR this is the whole of the page's metadata
 * handling; `<html lang>` is already maintained by the font preloader.
 */
function useDocumentMeta() {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    document.title = t('meta.title')
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', t('meta.description'))
  }, [t, i18n.resolvedLanguage])
}

export function LandingPage() {
  useDocumentMeta()

  return (
    <>
      <SiteHeader />
      {/* Clears the fixed 80px header. */}
      <main className="pt-20">
        <HeroCarousel />
        <AboutSection />
        <SectorsSection />
        <ContactSection />
      </main>
      <SiteFooter />
    </>
  )
}
